export const ANWBBrandRefreshThemeCurrent = {
    colors: {
        base: {
            textTitles: `#003d86`,
            textTitleLink: `#003d86`,
            textSubtitles: `#000307`,
            textBody: `#000307`,
            textLabel: `#000307`,
            textDescription: `#606060`,
            textSticker: `#003d86`,
            textLogo: `#004680`,
            textButton: `#003d86`,
            textTag: `#003d86`,
            textTabDefault: `#003d86`,
            textFormFieldInput: `#000307`,
            textPaginationDefault: `#000307`,
            textMainNavigation: `#003d86`,
            textTopbarNavigation: `#003d86`,
            textStickyNavigation: `#000307`,
            textFooterBar: `#003d86`,
            textSupport: `#000307`,
            textStepsbarSteps: `#003d86`,
            textPrice: `#003d86`,
            textPriceReceipt: `#000307`,
            bgFooter: `#003d86`,
            bgTabTabboxActive: `#003d86`,
            bgTooltip: `#003d86`,
            bgTooltipOnDark: `#ffffff`,
            bgButton: `#003d86`,
            bgDaypickerSelected: `#003d86`,
            bgSliderTrack: `#003d86`,
            borderTab: `#003d86`,
            borderTabbox: `#003d86`,
            borderSticker: `#e5e5e5`,
            borderButton: `#e5e5e5`,
            borderActive: `#003d86`,
            iconButton: `#003d86`,
            iconIllustrative: `#003d86`,
            iconUi: `#000307`,
            iconUiFill: `#000307`,
            iconPoi: `#003472`,
            iconHover: `#003472`,
            reviewGrade: `#000307`,
            reviewBar: `#003d86`,
            bgGalleryButton: `rgba(0, 3, 7, 0.15)`,
            overlay: `rgba(0,7,11,0.2)`,
            // License-plate bg country color
            licensePlate: `#003d86`,
            bgRatingItemSelected: `#003d86`,
            textCounter: `#003d86`,
            textNumber: `#000307`,
            textUsp: `#000307`,
            textDate: `#000307`,
            textIntro: `#003d86`,
            textBodyLinkHover: `#00628e`,
            // Link text used in link component.
            textLink: `#003d86`,
            // Footer-divider
            dividerFooter: `#ffffff`,
            // Text-quote
            textQuote: `#003d86`,
            // Color Change: Underline pagination
            underlinePagination: `#000307`,
            // Background chat
            bgChat: `#d9e2ed`,
            // Mobile main navigation
            textNavigationMainLabelActive: `#003d86`,
            bgBlocksPrimary: `#003d86`,
            bgBlocksPrimaryHover: `#002e65`,
            fillIndicationBarIndicator: `#003d86`,
            textPill: `#000307`,
            bgButtonHover: `#002e65`,
            borderButtonToggle: `#000307`,
            textButtonToggleOff: `#606060`,
            underlineButtonToggle: `#000307`,
            borderLicenseplate: `#003d86`,
            // Inactive text titles
            textTitlesInactive: `#606060`,
            // Inactive support text
            textSupportInactive: `#606060`,
            // Inactive body text
            textBodyInactive: `#606060`,
            // Default junction node
            borderNode: `#003d86`,
            // Default junction node
            textNode: `#003d86`,
            bgCardReview: `#003d86`,
            bgTagActive: `#003d86`,
            bgSearchlinkActive: `#003d86`,
            bgForm: `#003d86`,
            // Subtitles in secondary font
            textSubtitlesSecondary: `#003d86`,
            bgButtonFavorite: `rgba(0, 3, 7, 0.15)`,
            bgChipSelected: `#003d86`,
            // Content dimming overlay
            overlayNavigation: `rgba(0,3,7,0.4)`,
            // Navigation links hover
            textNavigationHover: `#0071a4`,
            overlaySearchWidget: `rgba(0,3,7,0.4)`,
            bgImagePreview: `rgba(96, 96, 96, 0.30)`,
            bgTilePrimary: `#003d86`,
            bgTilePrimaryHover: `#002e65`,
            bgTilePrimaryActive: `#00224a`,
            bgNavigationItemActive: `#003d86`,
            bgToast: `#003d86`,
            bgSticker: `#003d86`,
        },
        buttons: {
            textButtonTertiary: `#000307`,
            bgButtonDisabledOnLight: `#e5e5e5`,
            bgButtonDisabledOnMedium: `#a6a6a6`,
            bgButtonDisabledOnDark: `#a6a6a6`,
            // Bg primary button on every bg
            bgButtonPrimary: `#ffcd00`,
            // Bg Primary button hover
            bgButtonPrimaryHover: `#f2b91d`,
            // Bg primary button active state
            bgButtonPrimaryActive: `#e6b01c`,
            // Bg secondary button
            bgButtonSecondary: `#003d86`,
            // Bg secondary button hover
            bgButtonSecondaryHover: `#002e65`,
            // Bg secondary button active state
            bgButtonSecondaryActive: `#00224a`,
            // Bg secondary onDark button
            bgButtonSecondaryOnDark: `#ffffff`,
            // Bg secondary onDark button hover state
            bgButtonSecondaryOnDarkHover: `#e5e5e5`,
            bgButtonSecondaryOnDarkActive: `#d9d9d9`,
            // Outline tertiary button
            borderButtonTertiary: `#e5e5e5`,
            // Bg tertiary button hover state
            bgButtonTertiaryHover: `#e5e5e5`,
            bgButtonTertiaryActive: `#d9d9d9`,
            // Border tertiary button on medium bg
            borderButtonTertiaryOnMedium: `#d9d9d9`,
            // Bg tertiary button hover on medium bg
            bgButtonTertiaryOnMediumHover: `#d9d9d9`,
            // Bg tertiary button active on medium bg
            bgButtonTertiaryOnMediumActive: `#cccccc`,
            borderButtonTertiaryOnDark: `#ffffff`,
            bgButtonTertiaryOnDarkHover: `#002e65`,
            borderButtonTertiaryOnDarkHover: `#002e65`,
            bgButtonTertiaryOnDarkActive: `#00224a`,
            borderButtonTertiaryOnDarkActive: `#00224a`,
            textButtonDisabled: `#606060`,
            // Text-button-disabled-onMedium & onDark
            textButtonDisabledOnMedium: `#f2f2f2`,
            textButtonPrimary: `#003d86`,
            textButtonSecondary: `#ffffff`,
            textButtonSecondaryOnDark: `#003d86`,
            textButtonTertiaryOnDark: `#ffffff`,
            borderButtonTertiaryOnMediumActive: `#cccccc`,
            borderButtonTertiaryActive: `#d9d9d9`,
            textButtonDisabledOnDark: `#f2f2f2`,
            textButtonToast: `#000307`,
        },
        highlight: {
            textIntro: `#000307`,
            textInteractive: `#003d86`,
            textLink: `#0071a4`,
            textHover: `#002e65`,
            bgToggleOn: `#0096da`,
            borderSelected: `#0096da`,
            borderHover: `#002e65`,
            borderSliderHandle: `#003d86`,
            borderDotScale: `#003d86`,
            iconButton: `#0096da`,
            iconInteractive: `#003d86`,
            iconFormField: `#003d86`,
            dotScaleFilled: `#003d86`,
            indicatorHover: `#0096da`,
            iconHover: `#002e65`,
            textSubtitles: `#0096da`,
            // Text-tab-hover
            textTabHover: `#003472`,
            underlinePaginationHover: `#003472`,
            textInteractiveOnDark: `#59bbe7`,
            borderPillActive: `#0096da`,
            iconPillActive: `#0096da`,
            fillProgressBar: `#0096da`,
            bgPillIndicator: `#0096da`,
            // Radio button selected fill
            fillRadioButton: `#0096da`,
            textLinkSupport: `#0071a4`,
            // Interactive junction node
            textNodeInteractive: `#0096da`,
            // Interactive junction node
            borderNodeInteractive: `#0096da`,
            bgCardInformational: `#0096da`,
            textInteractiveOnLight: `#0071a4`,
            bgSticker: `#0071a4`,
            borderFormFieldFocus: `#0096da`,
            iconTooltip: `#0096da`,
            iconTooltipHover: `#0071a4`,
            borderFormFieldHover: `#0096da`,
            bgRadiocheckboxFocus: `#0071a4`,
            bgRadiocheckboxSelected: `#0096da`,
            bgRadiocheckboxSelectedHover: `#0071a4`,
            bgRadiocheckboxSelectedOnDark: `#59bbe7`,
            bgRadiocheckboxSelectedHoverOnDark: `#0096da`,
            // Focus state onlight and onMedium
            borderFocus: `#0080b9`,
            // Focus border onDark background
            borderFocusOnDark: `#59bbe7`,
            borderFormFieldOnDarkHover: `#59bbe7`,
            borderFormFieldOnDarkFocus: `#59bbe7`,
            borderFormFieldOnMediumHover: `#0096da`,
            borderFormFieldOnMediumFocus: `#0096da`,
            iconButtonHover: `#0071a4`,
        },
        dark: {
            textDark: `#000000`,
            textPrintversion: `#000000`,
            textLicenseplate: `#000000`,
            textLabel: `#000307`,
            textSticker: `#000307`,
            overlayPopover: `rgba(0,7,11,0.2)`,
            bgRadiocheckboxPressed: `#000307`,
            fillQrCode: `#000307`,
            // Price text used in product cards
            textPrice: `#000307`,
        },
        blanc: {
            textInverse: `#ffffff`,
            textLinkInverse: `#59bbe7`,
            textLinkUnderlined: `#59bbe7`,
            textButton: `#ffffff`,
            textSticker: `#ffffff`,
            textBreadcrumbHover: `#002e65`,
            // Text used on white tooltip
            textTooltip: `#606060`,
            textTooltipOnDark: `#ffffff`,
            titleFooter: `#ffffff`,
            titleInverse: `#ffffff`,
            bgChevronDown: `#ffffff`,
            bgReceipt: `#f2f2f2`,
            bgButton: `#ffffff`,
            bgFormField: `#ffffff`,
            bgSite: `#ffffff`,
            bgSubNavigation: `rgba(255, 255, 255, 0.60)`,
            bgSpeechbubble: `#ffffff`,
            bgBlock: `#ffffff`,
            bgSticker: `#ffffff`,
            bgModal: `#ffffff`,
            bgWidget: `#ffffff`,
            bgTabboxContent: `#ffffff`,
            bgStickyMenu: `#ffffff`,
            // Active tab
            bgTabTabboxHierarchical: `#ffffff`,
            bgFooterBar: `#ffffff`,
            bgMainNavigation: `#ffffff`,
            bgCards: `#ffffff`,
            bgCompareTable: `#ffffff`,
            bgDropdown: `#ffffff`,
            bgTicketContent: `#ffffff`,
            bgReviews: `#ffffff`,
            bgFilterMobile: `#ffffff`,
            bgSliderHandle: `#003d86`,
            bgStepsbarSteps: `#ffffff`,
            bgCheckbookOptions: `#ffffff`,
            bgModalLoginLeft: `#ffffff`,
            bgDaypicker: `#ffffff`,
            bgGalleryIndicator: `#ffffff`,
            bgEvent: `#ffffff`,
            bgBarSocial: `#ffffff`,
            bgBarSteps: `#ffffff`,
            bgBarUsp: `#ffffff`,
            bgBarTheme: `#ffffff`,
            bgNavigationTabActive: `#ffffff`,
            borderButton: `#ffffff`,
            iconUi: `#ffffff`,
            iconButton: `#ffffff`,
            iconTooltip: `#003d86`,
            iconSocial: `#ffffff`,
            iconGalleryButton: `#ffffff`,
            indicatorDefault: `#ffffff`,
            bgPanelSelect: `#ffffff`,
            borderRatingItem: `#ffffff`,
            borderButtonInverse: `#ffffff`,
            textButtonInverse: `#ffffff`,
            iconInteractiveInverse: `#ffffff`,
            textSupportInverse: `#ffffff`,
            // Icon-toggle
            iconToggle: `#ffffff`,
            // Bg-ticket-counterfoil
            bgTicketCounterfoil: `#ffffff`,
            // Bg-ticket-counterfoil
            bgTicketCounterfoil75: `rgba(255,255,255,0.75)`,
            // Bg-button-toggle
            bgButtonToggleOn: `#003d86`,
            // Bg-tabbox-inverted
            bgTabboxInverted: `#ffffff`,
            // Bg-dot-scale-default
            bgDotScaleDefault: `#ffffff`,
            // License-plate-text
            licensePlateText: `#ffffff`,
            // Footer-divider
            footerDivider: `#ffffff`,
            // Text-tab-active
            textTabActive: `#ffffff`,
            bgPill: `#ffffff`,
            bgStickyBar: `#ffffff`,
            bgPopover: `#ffffff`,
            bgButtonToggleOff: `#ffffff`,
            iconButtonToggleOn: `#ffffff`,
            textButtonToggleOn: `#ffffff`,
            bgTable: `#ffffff`,
            overlayColorPicker: `rgba(255, 255, 255, 0.3)`,
            bgForm: `#f2f2f2`,
            // Default junction node
            bgNode: `#ffffff`,
            bgPanelInformative: `#ffffff`,
            bgPanelFeaturedInverted: `#ffffff`,
            dividerInverse: `#ffffff`,
            fillIndicatorRadiocheckbox: `#ffffff`,
            bgQrCode: `#ffffff`,
            iconIllustrativeOnDark: `#ffffff`,
            bgSubNavigationHover: `#ffffff`,
        },
        light: {
            bgLabels: `#f2f2f2`,
            bgReceiptPrice: `#f2f2f2`,
            bgMediaPlaceholder: `#f2f2f2`,
            bgCounter: `#f2f2f2`,
            bgToggle: `#f2f2f2`,
            bgReviewBar: `#f2f2f2`,
            bgSliderRail: `#e5e5e5`,
            bgModalLoginRight: `#f2f2f2`,
            bgNavigationTab: `#f2f2f2`,
            bgIndicator: `#f2f2f2`,
            borderReceipt: `#f2f2f2`,
            borderStickyMenu: `#e5e5e5`,
            borderDropdown: `#e5e5e5`,
            borderThemeRow: `#e5e5e5`,
            borderSpeechBubble: `#e5e5e5`,
            borderTabboxContent: `#e5e5e5`,
            borderTabTabboxHierarchical: `#e5e5e5`,
            borderQuotelage: `#e5e5e5`,
            borderGallerySlider: `#e5e5e5`,
            borderPanelProduct: `#e5e5e5`,
            borderNavigationTab: `#e5e5e5`,
            divider: `#e5e5e5`,
            dividerReceipt: `#e5e5e5`,
            dividerInterrupted: `#e5e5e5`,
            dividerModal: `#e5e5e5`,
            dividerCards: `#e5e5e5`,
            dividerPagination: `#e5e5e5`,
            dividerTabbox: `#e5e5e5`,
            dividerFilter: `#e5e5e5`,
            dividerCarousel: `#e5e5e5`,
            dividerReviews: `#e5e5e5`,
            dividerFaq: `#e5e5e5`,
            dividerCheckBook: `#e5e5e5`,
            dividerAccordion: `#e5e5e5`,
            scrollbarModal: `#e5e5e5`,
            indicatorDefault: `#e5e5e5`,
            // Border tabbox inverted color
            borderTabboxInverted: `#e5e5e5`,
            // Border panel select color
            borderPanelSelect: `#e5e5e5`,
            borderFormFieldDisabled: `#e5e5e5`,
            bgInputstepper: `#e5e5e5`,
            borderGalleryThumbnail: `#e5e5e5`,
            bgBlocksSecondaryHover: `#e5e5e5`,
            bgCompareTable: `#f2f2f2`,
            borderPill: `#e5e5e5`,
            bgTableColumn: `#e5e5e5`,
            borderImageUpload: `#e5e5e5`,
            borderTable: `#e5e5e5`,
            borderPanelInformative: `#e5e5e5`,
            bgCookieConsent: `#f2f2f2`,
            bgTagHover: `#e5e5e5`,
            bgRadiocheckboxDisabled: `#e5e5e5`,
            bgFormFieldDisabledOnMedium: `#d9d9d9`,
            bgChipHover: `#e5e5e5`,
            bgTileSecondaryHover: `#e5e5e5`,
            bgTileSecondaryActive: `#d9d9d9`,
        },
        extralight: {
            bgBarTheme: `#f2f2f2`,
            bgCards: `#e5e5e5`,
            bgBarFaq: `#f2f2f2`,
            bgBarUsp: `#f2f2f2`,
            bgBarSocial: `#f2f2f2`,
            bgBarSteps: `#f2f2f2`,
            bgBarNews: `#f2f2f2`,
            bgTabTabboxDefault: `#f2f2f2`,
            bgCommentBlock: `#f2f2f2`,
            bgTag: `#f2f2f2`,
            bgPanelLogin: `#f2f2f2`,
            bgSelectedText: `#e6f1f8`,
            bgNotificationInformative: `#ebf2fa`,
            bgLabels: `#f2f2f2`,
            bgTabCompareTableSelected: `#f2f2f2`,
            bgCompareTable: `#f2f2f2`,
            bgWidget: `#f2f2f2`,
            bgDaypicker: `#f2f2f2`,
            bgReviewAnswer: `#f2f2f2`,
            bgTabboxContent: `#f2f2f2`,
            bgTicket: `#e5e5e5`,
            bgStepsbarSteps: `#f2f2f2`,
            bgCheckbook: `#f2f2f2`,
            bgAccordion: `#f2f2f2`,
            bgTabTabboxHierarchical: `#f2f2f2`,
            borderCards: `#e5e5e5`,
            borderCardsRedesign: `#e5e5e5`,
            bgRatingItem: `#f2f2f2`,
            bgFormFieldDisabled: `#e5e5e5`,
            // Bg-tab-inverted
            bgTabInverted: `#f2f2f2`,
            // Bg-ticket-counterfoil
            bgTicketCounterfoil: `#f2f2f2`,
            // Bg-site
            bgSite: `#f2f2f2`,
            bgGalleryButtonDisabled: `#e5e5e5`,
            bgFormFieldAutosuggest: `#f2f2f2`,
            bgSubNavigation: `#f2f2f2`,
            // Mobile main navigation
            bgNavigationMainLabelActive: `#ffffff`,
            bgBlocksSecondary: `#f2f2f2`,
            fillIndicationBar: `#f5f5f5`,
            bgPillHover: `#f5f5f5`,
            bgPillOpen: `#f5f5f5`,
            bgRouting: `#f2f2f2`,
            bgPanelFeatured: `#f2f2f2`,
            borderPanelFeatured: `#f2f2f2`,
            bgSearchlinkHover: `#f2f2f2`,
            dividerList: `#f2f2f2`,
            bgNotificationPromotional: `#f2f2f2`,
            bgFormField: `#f2f2f2`,
            bgChip: `#f2f2f2`,
            bgTileSecondary: `#f2f2f2`,
            bgNavigationItemHover: `#f2f2f2`,
        },
        medium: {
            textInactive: `#a6a6a6`,
            textBreadcrumb: `#003d86`,
            bgTabCompareTable: `#e5e5e5`,
            bgApplication: `#f2f2f2`,
            borderFormField: `#606060`,
            borderCompareTable: `rgba(191,219,237,0)`,
            dividerCompareTable: `#a6a6a6`,
            borderButtonInverseHover: `#e5e5e5`,
            textButtonInverseHover: `#ffffff`,
            iconInverseHover: `#59bbe7`,
            textLinkInverseHover: `#ffffff`,
            // Icon-inactive
            iconInactive: `#a6a6a6`,
            underlinePaginationInactive: `#a6a6a6`,
            borderPillHover: `#606060`,
            dividerTable: `#a6a6a6`,
            bgProgressBar: `#e5e5e5`,
            borderForms: `#e5e5e5`,
            // Radio button hover fill
            fillRadioButtonHover: `#e5e5e5`,
            timelineElementInactive: `#e5e5e5`,
            bgReceiptButton: `#e5e5e5`,
            textFormFieldDisabled: `#a6a6a6`,
            bgRadiocheckboxDisabled: `#a6a6a6`,
            fillIndicatorRadiocheckbox: `#a6a6a6`,
            borderButtonOnMedium: `#a6a6a6`,
            textDisabled: `#a6a6a6`,
            textInactiveOnMedium: `#999999`,
            iconInactiveOnMedium: `#999999`,
        },
        gradients: {
            // Button background primary decide
            bgButtonPrimaryDecide: `#ffcd00`,
            // Hover button primary color
            bgButtonPrimaryDecideHover: `#f2b91d`,
            bgButtonPrimaryDecideActive: `#f2b91d`,
            // Button background primary, breadcrumb background
            bgButtonPrimary: `#003d86`,
            bgButtonPrimaryHover: `#002e65`,
            bgButtonSecondaryHover: `#e5e5e5`,
            borderButtonSecondaryHover: `#e5e5e5`,
            bgButtonSecondaryActive: `#e5e5e5`,
            bgButtonPrimaryActive: `#002e65`,
            bgButtonTertiaryDecide: `#ffcd00`,
            bgButtonTertiaryDecideHover: `#f2b91d`,
            bgButtonTertiaryDecideActive: `#f2b91d`,
            bgButtonTertiary: `#003d86`,
            bgButtonTertiaryHover: `#002e65`,
            bgButtonTertiaryActive: `#002e65`,
            bgBreadcrumb: `#ffffff`,
            overlayPagebreaker: `linear-gradient(90deg, #003d86bf 0%, #003d8666 74.1%, #003d8659 100%)`,
            overlayReadMore: `linear-gradient(180deg, #ffffff00 0%, #ffffff 100%)`,
            overlayHeroImage: `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(1, 26, 55, 0.2) 100%)`,
            overlayHorizontalScroll: `linear-gradient(270deg, #ffffff 5.01%, rgba(255, 255, 255, 0) 96.61%);`,
            overlayColorPickerLight: `linear-gradient(98deg, rgba(0, 0, 0, 0.03) 26%, rgba(0, 0, 0, 0) 28%),linear-gradient(90deg, rgba(255, 255, 255, 0) 7%, rgba(0, 0, 0, 0.1) 84%)`,
            overlayColorPickerDark: `linear-gradient(98deg, rgba(0, 0, 0, 0.1) 26%, rgba(0, 0, 0, 0) 28%),linear-gradient(90deg, rgba(255, 255, 255, 0) 7%, rgba(0, 0, 0, 0.2) 85%)`,
            bgButtonIconPressed: `#003d86`,
        },
        accent: {
            bgMainNavigation: `#f2f2f2`,
            bgStickerInformative: `#ffcd00`,
            bgFormFieldLicensePlate: `#ffcd00`,
            bgProductBar: `#ffcd00`,
            iconStarRating: `#ffcd00`,
            // Another yellow color is used for the hover
            bgPanelPromotionalHover: `#f2b91d`,
            bgLabel: `#ffcd00`,
            // StickerArrow informational bg shadow
            bgSticker3D: `#cca400`,
            bgPanelPromotional: `#ffcd00`,
            borderPanelPromotional: `#ffcd00`,
            bgButtonLinkImage: `#ffcd00`,
        },
        informative: {
            // Notification informative title
            titleNotification: `#000307`,
            subTitlePrice: `#606060`,
            textDescription: `#606060`,
            textSupport: `#606060`,
            textFormField: `#606060`,
            textPrice: `#0071a4`,
            textDate: `#000307`,
            bgSelectedText: `#606060`,
            // Informative notification
            borderNotification: `#003d86`,
            iconInformative: `#003d86`,
            timelineElement: `#606060`,
            // Text-informative
            textInformative: `#606060`,
            fillSpinner: `#606060`,
        },
        action: {
            textAction: `#f28200`,
            textActive: `#002e65`,
            textMember: `#f28200`,
            textMemberPrice: `#f28200`,
            iconActive: `#002e65`,
            indicatorActive: `#f28200`,
            underlinePaginationActive: `#0071a4`,
            // Text tab active color
            textTabActive: `#f28200`,
            borderClicked: `#f28200`,
            iconClicked: `#f28200`,
            borderButtonInverseActive: `#ffffff`,
            textButtonInverseActive: `#ffffff`,
            textBodyLinkActive: `#f28200`,
            // All links used on dark background.
            textLinkInverseActive: `#f28200`,
            // Text-clicked
            textClicked: `#f28200`,
            borderPillClicked: `#000307`,
        },
        promotional: {
            bgSticker: `#cc2c26`,
            bgLabel: `#cc2c26`,
            // Icon-favorite-active
            iconFavoriteActive: `#cc2c26`,
            // StickerArrow promotional bg shadow
            bgSticker3D: `#a3231e`,
            bgButtonLinkImage: `#cc2c26`,
        },
        stickers: {
            bgStickerPromotional: `#cc2c26`,
            bgStickerInformative: `#0071a4`,
            bgStickerSocietal: `#207100`,
            bgStickerProduct: `#003d86`,
            bgStickerMemberBenefit: `#ffcd00`,
            bgStickerDate: `rgba(255,255,255,0.1)`,
            textStickerMemberBenefit: `#003d86`,
            textSticker: `#ffffff`,
            bgStickerCampaign: `#f2f2f2`,
            textStickerSoldout: `#cc2c26`,
            bgStickerSoldout: `#ffffff`,
        },
        positive: {
            // Notification positive
            titleNotification: `#000307`,
            // Notification positive
            bgNotification: `#e8f4ec`,
            // Notification positive
            borderNotification: `#0e7d33`,
            iconCheck: `#0e7d33`,
            iconUsp: `#0e7d33`,
            iconNotification: `#0e7d33`,
            // Positive feedback
            borderFormField: `#0e7d33`,
            // Positive feedback
            textSupport: `#0e7d33`,
            textPrice: `#0e7d33`,
            // StickerArrow sustainable bg shadow
            bgSticker3D: `#1a5a00`,
            // Bg sticker sustainable
            bgSticker: `#207100`,
            textFieldValidationInverse: `#9fd1b0`,
            borderFormFieldOnDark: `#9fd1b0`,
            bgToast: `#0e7d33`,
        },
        warning: {
            // Notification warning
            titleNotification: `#000307`,
            // notification warning
            bgNotification: `#fef7eb`,
            // Notification warning
            borderNotification: `#f29900`,
            // notification-warning
            iconNotification: `#f29900`,
        },
        error: {
            // Notification error
            titleNotification: `#000307`,
            textSupport: `#bb0606`,
            textFieldValidation: `#bb0606`,
            bgNotification: `#faebeb`,
            // Notification error
            borderNotification: `#bb0606`,
            borderFormField: `#bb0606`,
            // Notification error
            iconNotification: `#bb0606`,
            iconError: `#bb0606`,
            textFieldValidationInverse: `#eab2b2`,
            borderFormFieldOnDark: `#eab2b2`,
            bgToast: `#bb0606`,
        },
        statusIndicators: {
            light: `#9fd1b0`,
            medium: `#f29900`,
            heavy: `#bb0606`,
            extreme: `#000000`,
        },
        visited: {
            // Visited link color only in Search and filter applications
            visitedTextLink: `#6e0078`,
        },
        membership: {
            // Membershipcard color: 0 - 2 years
            '2Years': `#37b4e6`,
            // Membershipcard color: 2 - 5 years
            '5Years': `#bb9975`,
            // Membershipcard color: 5 - 10 years
            '10Years': `#dad9d7`,
            // Membershipcard color: 10 - 25 years
            '15Years': `#d6b76f`,
            // Membershipcard color: > 25 years
            '25Years': `#cdc4b3`,
        },
        socialIcons: {
            bgIconTwitter: `#000307`,
            bgIconInstagram: `#f10176`,
            bgIconLinkedin: `#51a0c9`,
            bgIconFacebook: `#3b5998`,
            bgIconYoutube: `#ff0000`,
            bgIconAnwbApps: `#ffcd00`,
            bgIconNewsletter: `#ffcd00`,
            bgIconPodcast: `#ffcd00`,
        },
        shadows: {
            shadowNeutralExtraLight: `#e6f1f8`,
            shadowBase: `#003e8033`,
            shadowDark: `rgba(0,3,7,0.15)`,
        },
        labels: {
            bgLabelSocietal: `#207100`,
            bgLabelInformative: `#0071a4`,
            bgLabelProduct: `#003d86`,
            bgLabelMemberBenefit: `#ffcd00`,
            bgLabelDate: `rgba(255,255,255,0.1)`,
            textLabelMemberBenefit: `#003d86`,
            textLabel: `#ffffff`,
            bgLabelEnergyA: `#207100`,
            bgLabelEnergyB: `#268500`,
            bgLabelEnergyC: `#bcd9b0`,
            bgLabelEnergyD: `#ffcd00`,
            bgLabelEnergyE: `#f29900`,
            bgLabelEnergyF: `#ee4406`,
            bgLabelEnergyG: `#bb0606`,
            textLabelEnergy: `#000000`,
            bgLabelCampaign: `#f2f2f2`,
            textLabelSoldout: `#cc2c26`,
            bgLabelSoldout: `#ffffff`,
        },
    },
    fontFamilies: {
        primary: `Clan Pro`,
        secondary: `Bernina Sans`,
        human: `Verveine`,
    },
    letterSpacing: {
        0: `0`,
    },
    paragraphSpacing: {
        0: `0`,
        100: `8`,
        200: `12`,
        300: `16`,
        400: `24`,
        500: `40`,
        600: `56`,
    },
    lineHeights: {
        0: `auto`,
        100: `14`,
        200: `16`,
        300: `18`,
        400: `20`,
        500: `22`,
        600: `24`,
        700: `26`,
        800: `28`,
        850: `32`,
        900: `36`,
        1000: `38`,
        1100: `44`,
        1200: `58`,
        1300: `72`,
    },
    fontSize: {
        100: `11`,
        200: `12`,
        300: `14`,
        400: `16`,
        500: `18`,
        600: `20`,
        700: `22`,
        800: `24`,
        900: `26`,
        // Based on default
        950: `30`,
        1000: `28`,
        1100: `32`,
        1200: `36`,
        1500: `48`,
        1900: `64`,
    },
    fontWeights: {
        primaryMedium: `Medium`,
        primaryBold: `Bold`,
        primaryNews: `News`,
        primaryStickerText: `NarrowBold`,
        secondaryRegular: `Regular`,
        secondaryMedium: `Medium`,
        secondarySemiBold: `SemiBold`,
        secondaryItalic: `Italic`,
        // Based on default
        primarySemiBoldItalic: `SemiBold Italic`,
        // Based on default
        primarySemiBold: `SemiBold`,
        // Based on default
        primaryBoldItalic: `Bold Italic`,
        // Based on default
        primaryRegular: `Regular`,
    },
    typography: {
        heading1: {
            // test description
            '800PageTitleDesktop': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `58`,
                fontSize: `48`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '700PageTitleTablet': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `44`,
                fontSize: `36`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '600PageTitleMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `38`,
                fontSize: `28`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading2: {
            '500GroupComponentTitle': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `44`,
                fontSize: `32`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '500GroupComponentTitleMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `38`,
                fontSize: `28`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '1000GroupComponentTitleXl': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `72`,
                fontSize: `64`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '1000GroupComponentTitleXlMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `44`,
                fontSize: `36`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading3: {
            '400ContentTitle': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `36`,
                fontSize: `26`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '400ContentTitleMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `28`,
                fontSize: `22`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading4: {
            '300ComponentTitle': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '300ComponentTitleLink': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '300ComponentTitleMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `24`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '300ComponentTitleSlimS': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `32`,
                fontSize: `24`,
                letterSpacing: `0`,
            },
            '300ComponentTitleSlimSMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `24`,
                fontSize: `18`,
                letterSpacing: `0`,
            },
            '300ComponentTitleSlimXs': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
            },
            '300ComponentTitleSlimXsMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `22`,
                fontSize: `16`,
            },
        },
        heading5: {
            '200ComponentSubTitle': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `22`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200ComponentSubTitleLinethrough': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `22`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `line-through`,
            },
            '200NotificationTitle': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `22`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading6: {
            '100ContentSubTitle': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `28`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100ListTitle': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `28`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100CurrentStateText': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100SuggestionText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100ComponentLink': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100ComponentLinkMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `24`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading7: {
            '75LabelTitle': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75TooltipTitle': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `22`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        labels: {
            // Label-text used in element 'Labels'
            '75LabelText': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `22`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75LabelTextMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                fontSize: `12`,
                letterSpacing: `0`,
                lineHeight: `14`,
            },
        },
        paragraphs: {
            '100BodyText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            // Italic body style for history text
            '100BodyTextItalic': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                fontStyle: `Italic`,
                lineHeight: `24`,
                fontSize: `16`,
            },
            '100IntroText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `26`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100LinkText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `26`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `Underline`,
            },
            '100NotificationText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `22`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            // Quote
            '300Quote': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `24`,
                fontSize: `22`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75BodyTextXs': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `22`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        captions: {
            '50SupportText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `18`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50TooltipText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `22`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50BreadcrumbText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `18`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50FooterLink': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `18`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            // support-link-text
            '50SupportLinkText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `18`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `Underline`,
            },
            '50LabelTitleXxs': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `18`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        formFields: {
            '100FieldHintText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100FieldText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50FieldValidation': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `18`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        buttons: {
            '100ButtonLink': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `20`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75ButtonLinkXs': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `16`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75TagText': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `16`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        numbersPricesAndUsPs: {
            '800CounterNumber': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `44`,
                fontSize: `36`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200Number': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '400StickerTextNumberM': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `26`,
                fontSize: `24`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200StickerTextNumberS': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `14`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '550PriceTextXxl': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `36`,
                fontSize: `26`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '500PriceTextXl': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `32`,
                fontSize: `24`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '550PriceTextXxlMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `24`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '500PriceTextXlMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `24`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '400PriceTextL': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200PriceTextM': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `26`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '300PriceTextLMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `24`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200PriceTextMMobile': {
                fontFamily: `Clan Pro`,
                fontWeight: `News`,
                lineHeight: `22`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75PriceTextS': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `22`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75PriceTextSSlim': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75PriceTextSSecondary': {
                fontFamily: `Bernina Sans`,
                fontWeight: `SemiBold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50PriceTextXs': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `22`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100DateTextM': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `26`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75DateTextS': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `22`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100UspTextM': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `26`,
                fontSize: `18`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50UspTextS': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `22`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '400LicensePlate': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `36`,
                fontSize: `26`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        stickers: {
            '100StickerTextL': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `20`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50StickerTextM': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `16`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '25StickerTextS': {
                fontFamily: `Clan Pro`,
                fontWeight: `Medium`,
                lineHeight: `14`,
                fontSize: `12`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
    },
    borderRadius: {
        xs: `2`,
        s: `4`,
        m: `8`,
        rounded: `100`,
    },
    uiSize: {
        // default
        default: `20`,
        // xs
        xs: `16`,
    },
    colorOpacity: {
        0: `0%`,
        20: `20%`,
        40: `40%`,
        // Based on default
        50: `50%`,
        60: `60%`,
        80: `80%`,
        100: `100%`,
    },
    borderWidth: {
        // is going to be deprecated
        1: `1`,
        // border width small
        2: `1`,
        // border width medium
        m: `2`,
    },
    spacing: {
        50: `4`,
        100: `8`,
        200: `12`,
        // Based on default
        250: `14`,
        300: `16`,
        // Based on default
        350: `20`,
        400: `24`,
        450: `32`,
        500: `40`,
        600: `56`,
        650: `64`,
        700: `80`,
        800: `120`,
        900: `160`,
        1000: `240`,
        1100: `400`,
        1200: `560`,
        1300: `800`,
    },
    illustrativeSize: {
        default: `55`,
    },
    poiSize: {
        default: `20`,
    },
    stickerSize: {
        mobile: `70`,
        desktop: `85`,
        // Sticker size rating panel
        rating: `40`,
    },
    // These values are offset and do not correspond to the Figma theme. See the README of @anwb/theme for more information.
    viewportBreakpoint: {
        xxs: `300`,
        xs: `450`,
        sm: `562.5`,
        md: `768.75`,
        lg: `960`,
        xl: `1200`,
    },
    boxShadow: {
        baseBottom: {
            x: `0`,
            y: `2`,
            blur: `4`,
            spread: `0`,
            color: `#003e8033`,
            type: `innerShadow`,
        },
        lightBottom: {
            x: `0`,
            y: `1`,
            blur: `4`,
            spread: `0`,
            color: `rgba(0,3,7,0.15)`,
            type: `innerShadow`,
        },
        baseTop: {
            x: `0`,
            y: `-2`,
            blur: `4`,
            spread: `0`,
            color: `rgba(0,3,7,0.15)`,
            type: `innerShadow`,
        },
        darkStickyBar: {
            x: `0`,
            y: `2`,
            blur: `12`,
            spread: `0`,
            color: `rgba(0,3,7,0.15)`,
            type: `dropShadow`,
        },
        popover: {
            x: `0`,
            y: `10`,
            blur: `30`,
            spread: `0`,
            color: `rgba(0,3,7,0.15)`,
            type: `dropShadow`,
        },
        card: {
            x: `0`,
            y: `8`,
            blur: `32`,
            spread: `0`,
            color: `rgba(0,3,7,0.15)`,
            type: `dropShadow`,
        },
        inputfield: {
            x: `0`,
            y: `8`,
            blur: `32`,
            spread: `0`,
            color: `rgba(0,3,7,0.15)`,
            type: `dropShadow`,
        },
        tooltip: {
            x: `0`,
            y: `8`,
            blur: `32`,
            spread: `0`,
            color: `rgba(0,3,7,0.15)`,
            type: `dropShadow`,
        },
        toast: {
            x: `0`,
            y: `0`,
            blur: `10`,
            spread: `0`,
            color: `rgba(0,3,7,0.25)`,
            type: `dropShadow`,
        },
        iconUi: {
            x: `0`,
            y: `2`,
            blur: `6`,
            spread: `0`,
            color: `rgba(0,0,0,0.1)`,
            type: `innerShadow`,
        },
    },
    fontFallbacks1: `Apple SD Gothic Neo`,
    fontFallbacks2: `Calibri`,
    fontFallbacks3: `Roboto`,
    fontFallbacks4: `Verdana`,
    componentLayoutSizing: {
        100: `1/4`,
        200: `1/3`,
        300: `2/3`,
        400: `1/2`,
        500: `1/1`,
    },
    easings: {
        // Default
        default: `.16,.16,.64,1`,
        // Caregiver
        caregiver: `.16,.16,.09,1`,
        // Expert
        expert: `.88,.29,.51,1`,
        // Guide
        guide: `.5,0,.5,1`,
        // Inspirator
        inspirator: `.28,0,.34,1.66`,
    },
    timing: {
        // Timing 100
        100: `100`,
        // Timing 200
        200: `150`,
        // Timing 300
        300: `200`,
        // Timing 400
        400: `250`,
        // Timing 500
        500: `300`,
        // Timing 600
        600: `500`,
        // Timing 700
        700: `750`,
        // Timing 800
        800: `1000`,
    },
    effect: {
        // Move
        move: `Move`,
        // Move in
        moveIn: `move in`,
        // Move out
        moveOut: `Move out`,
        // scale
        scale: `scale`,
        // color change
        colorChange: `color change`,
        // morph
        morph: `morph`,
        // rotate
        rotate: `rotate`,
        // pop
        pop: `pop`,
        // bounce
        bounce: `bounce`,
        // elastic
        elastic: `elastic`,
    },
    zIndex: {
        sticky: `600`,
        menu: `700`,
        logo: `800`,
        popUp: `900`,
        cookie: `1000`,
        tooltip: `1100`,
    },
    textDecoration: {
        none: `none`,
        lineThrough: `line-through`,
        underline: `Underline`,
    },
    containerWidth: {
        containerWidthMax: `1280`,
    },
    radiocheckbox: {
        hitbox: `28`,
        box: `24`,
    },
};
//# sourceMappingURL=anwb-brand-refresh-theme.js.map